import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Link } from "react-router-dom";
import { useState } from "react";
import { Users, Bed, Wifi, Car, Coffee, Bath, Phone, MapPin, Star, X } from "lucide-react";
import familyRoomNew1 from "@/assets/family-room-new-1.jpg";
import familyRoomNew2 from "@/assets/family-room-new-2.jpg";
import familyRoomNew3 from "@/assets/family-room-new-3.jpg";
import familyRoomNew4 from "@/assets/family-room-new-4.jpg";
import familyRoomNew5 from "@/assets/family-room-new-5.jpg";
import familyRoomNew6 from "@/assets/family-room-new-6.jpg";
import doubleRoomNew1 from "@/assets/double-room-new-1.jpg";
import doubleRoomNew2 from "@/assets/double-room-new-2.jpg";
import doubleRoomNew3 from "@/assets/double-room-new-3.jpg";
import doubleRoomNew4 from "@/assets/double-room-new-4.jpg";
import doubleRoomNew5 from "@/assets/double-room-new-5.jpg";
import doubleRoomNew6 from "@/assets/double-room-new-6.jpg";
import singleRoomNew1 from "@/assets/single-room-new-1.jpg";
import singleRoomNew2 from "@/assets/single-room-new-2.jpg";
import singleRoomNew3 from "@/assets/single-room-new-3.jpg";
import singleRoomNew4 from "@/assets/single-room-new-4.jpg";
import singleRoomNew5 from "@/assets/single-room-new-5.jpg";
import singleRoomNew6 from "@/assets/single-room-new-6.jpg";
import twinRoom1 from "@/assets/twin-room-1.jpg";
import roomAmenitiesNew from "@/assets/room-amenities-new.jpg";
import outsideLodge from "@/assets/outside-lodge.jpg";
import safeAvif from "@/assets/safe.avif";
import teaCoffeeAmenities from "@/assets/rooms/tea-coffee-amenities.webp";
interface RoomDetailProps {
  roomType: "family" | "double" | "single";
}
const RoomDetail = ({
  roomType
}: RoomDetailProps) => {
  const [selectedImage, setSelectedImage] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImageIndex, setLightboxImageIndex] = useState(0);
  const openLightbox = (index: number) => {
    setLightboxImageIndex(index);
    setLightboxOpen(true);
  };
  const nextImage = () => {
    const room = roomData[roomType];
    setLightboxImageIndex(prev => (prev + 1) % room.images.length);
  };
  const prevImage = () => {
    const room = roomData[roomType];
    setLightboxImageIndex(prev => (prev - 1 + room.images.length) % room.images.length);
  };
  const roomData = {
    family: {
      name: "Tembo Family Suite",
      category: "Family Suite",
      images: [familyRoomNew1, familyRoomNew2, familyRoomNew3, familyRoomNew4, familyRoomNew5, familyRoomNew6, safeAvif, teaCoffeeAmenities],
      description: "Our spacious family suite offers the perfect blend of comfort and elegance for families traveling together. Featuring separate sleeping areas and modern amenities, this beautifully appointed suite provides ample space for relaxation while maintaining the intimate atmosphere that makes Kijani Arusha Airport Lodge special.",
      capacity: "Up to 6 guests",
      area: "45 sqm",
      bedType: "1 King Bed + 2 Single Beds",
      price: "From $180/night",
      rating: 4.8,
      amenities: [{
        icon: Wifi,
        text: "Complimentary Wi-Fi"
      }, {
        icon: Car,
        text: "Air Conditioning"
      }, {
        icon: Bath,
        text: "En-suite Bathroom with Premium Amenities"
      }, {
        icon: Coffee,
        text: "Mini Fridge & Coffee Station"
      }, {
        icon: Phone,
        text: "In-room Safe"
      }, {
        icon: Users,
        text: "24/7 Concierge Service"
      }, {
        icon: Coffee,
        text: "Daily Housekeeping"
      }, {
        icon: MapPin,
        text: "Private Terrace with Garden Views"
      }]
    },
    double: {
      name: "Simba Double Room",
      category: "Deluxe Room",
      images: [doubleRoomNew1, doubleRoomNew2, doubleRoomNew3, doubleRoomNew4, doubleRoomNew5, doubleRoomNew6, safeAvif, teaCoffeeAmenities],
      description: "Experience refined comfort in our signature double room, thoughtfully designed with authentic Tanzanian touches and modern conveniences. Whether configured with a king bed or twin beds, this elegant room serves as your peaceful retreat after exciting safari adventures.",
      capacity: "Up to 3 guests",
      area: "30 sqm",
      bedType: "1 King Bed or 2 Twin Beds",
      price: "From $150/night",
      rating: 4.7,
      amenities: [{
        icon: Wifi,
        text: "Complimentary Wi-Fi"
      }, {
        icon: Car,
        text: "Climate Control"
      }, {
        icon: Bath,
        text: "Luxury En-suite Bathroom"
      }, {
        icon: Coffee,
        text: "Mini Bar & Refreshment Center"
      }, {
        icon: Phone,
        text: "Digital Safe"
      }, {
        icon: Users,
        text: "Personal Butler Service"
      }, {
        icon: Coffee,
        text: "Turn-down Service"
      }, {
        icon: MapPin,
        text: "Private Balcony"
      }]
    },
    single: {
      name: "Duma Single Room",
      category: "Classic Room",
      images: [singleRoomNew1, singleRoomNew2, singleRoomNew3, singleRoomNew4, singleRoomNew5, singleRoomNew6, safeAvif, teaCoffeeAmenities],
      description: "Perfect for solo travelers seeking comfort and tranquility, our single room combines intimate luxury with all essential amenities. Every detail has been carefully considered to ensure your stay is both comfortable and memorable.",
      capacity: "Up to 1 guest",
      area: "20 sqm",
      bedType: "1 Single Bed",
      price: "From $120/night",
      rating: 4.6,
      amenities: [{
        icon: Wifi,
        text: "High-Speed Internet"
      }, {
        icon: Car,
        text: "Personal Climate Control"
      }, {
        icon: Bath,
        text: "Designer Bathroom with Rain Shower"
      }, {
        icon: Coffee,
        text: "Mini Fridge & Tea/Coffee Maker"
      }, {
        icon: Phone,
        text: "Electronic Safe"
      }, {
        icon: Users,
        text: "Dedicated Guest Relations"
      }, {
        icon: Coffee,
        text: "Premium Room Service"
      }, {
        icon: MapPin,
        text: "Garden View Window"
      }]
    }
  };
  const room = roomData[roomType];
  return <div className="min-h-screen bg-background">
      {/* Hero Section with Room Name */}
      <section className="py-16 bg-gradient-to-r from-primary/10 to-primary/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <span className="inline-block px-4 py-2 bg-primary/10 text-primary font-medium rounded-full text-sm mb-4">
              {room.category}
            </span>
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground mb-4">
              {room.name}
            </h1>
            <div className="flex items-center justify-center space-x-2 mb-6">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => <Star key={i} className={`h-5 w-5 ${i < Math.floor(room.rating) ? 'text-yellow-400 fill-current' : 'text-gray-300'}`} />)}
              </div>
              <span className="text-muted-foreground text-sm">({room.rating}/5.0)</span>
            </div>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              {room.description}
            </p>
          </div>
        </div>
      </section>

      {/* Standard Product Image Gallery */}
      <section className="py-12 bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Main Image Display */}
            <div className="lg:col-span-1">
              <button onClick={() => openLightbox(selectedImage)} className="w-full aspect-[4/3] rounded-lg overflow-hidden shadow-elegant cursor-pointer group">
                <img src={room.images[selectedImage]} alt={`${room.name} - View ${selectedImage + 1}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
              </button>
            </div>

            {/* Thumbnail Navigation */}
            <div className="lg:col-span-1">
              <div className="grid grid-cols-2 gap-4 mb-4">
                {room.images.slice(0, 4).map((image, index) => <button key={index} onClick={() => setSelectedImage(index)} className={`aspect-[4/3] rounded-lg overflow-hidden shadow-soft transition-all duration-200 ${selectedImage === index ? 'ring-2 ring-primary ring-offset-2' : 'hover:opacity-75'}`}>
                    <img src={image} alt={`${room.name} - Thumbnail ${index + 1}`} className="w-full h-full object-cover" />
                  </button>)}
              </div>
              
              {/* Additional thumbnails if more than 4 images */}
              {room.images.length > 4 && <div className="grid grid-cols-4 gap-2">
                  {room.images.slice(4).map((image, index) => <button key={index + 4} onClick={() => setSelectedImage(index + 4)} className={`aspect-square rounded-md overflow-hidden shadow-soft transition-all duration-200 ${selectedImage === index + 4 ? 'ring-2 ring-primary ring-offset-1' : 'hover:opacity-75'}`}>
                      <img src={image} alt={`${room.name} - Thumbnail ${index + 5}`} className="w-full h-full object-cover" />
                    </button>)}
                </div>}
            </div>
          </div>
        </div>
      </section>

      {/* Room Details Section */}
      <section className="py-16 bg-muted/50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            
            {/* Room Information */}
            <div className="lg:col-span-2">
              <Card className="shadow-elegant">
                <CardContent className="p-8">
                  <div className="mb-6">
                    <h2 className="font-heading text-3xl font-bold text-foreground mb-2">{room.name}</h2>
                    <p className="text-muted-foreground">{room.category}</p>
                  </div>

                  {/* Room Specs */}
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8 p-6 bg-muted/50 rounded-lg">
                    <div className="flex items-center space-x-3">
                      <Users className="h-6 w-6 text-primary" />
                      <div>
                        <p className="font-medium text-foreground">Capacity</p>
                        <p className="text-sm text-muted-foreground">{room.capacity}</p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="h-6 w-6 flex items-center justify-center">
                        <div className="w-4 h-4 border-2 border-primary rounded-sm"></div>
                      </div>
                      <div>
                        <p className="font-medium text-foreground">Area</p>
                        <p className="text-sm text-muted-foreground">{room.area}</p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      <Bed className="h-6 w-6 text-primary" />
                      <div>
                        <p className="font-medium text-foreground">Bed Type</p>
                        <p className="text-sm text-muted-foreground">{room.bedType}</p>
                      </div>
                    </div>
                  </div>

                  {/* Amenities */}
                  <div className="mb-8">
                    <h3 className="font-heading text-xl font-semibold text-foreground mb-4">Room Amenities</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {room.amenities.map((amenity, index) => <div key={index} className="flex items-center space-x-3 p-3 bg-background rounded-lg">
                          <amenity.icon className="h-5 w-5 text-primary flex-shrink-0" />
                          <span className="text-sm text-foreground">{amenity.text}</span>
                        </div>)}
                    </div>
                  </div>

                  <p className="text-muted-foreground leading-relaxed mb-8">
                    Experience the perfect blend of luxury and authenticity in this beautifully appointed accommodation. 
                    Each room is designed to provide maximum comfort while showcasing the natural beauty of Tanzania 
                    through carefully selected materials and thoughtful design elements.
                  </p>
                </CardContent>
              </Card>
            </div>

            {/* Booking Card */}
            <div className="lg:col-span-1">
              <Card className="shadow-elegant sticky top-8">
                <CardContent className="p-6">
                  <div className="text-center mb-6">
                    <h3 className="font-heading text-2xl font-bold text-foreground mb-2">Book This Room</h3>
                  </div>

                  <div className="space-y-4 mb-6">
                    <div className="flex items-center justify-between p-3 bg-muted/50 rounded-lg">
                      <span className="text-sm font-medium">Free Airport Transfer</span>
                      <span className="text-primary text-sm">✓ Included</span>
                    </div>
                    <div className="flex items-center justify-between p-3 bg-muted/50 rounded-lg">
                      <span className="text-sm font-medium">Daily Breakfast</span>
                      <span className="text-primary text-sm">✓ Included</span>
                    </div>
                    <div className="flex items-center justify-between p-3 bg-muted/50 rounded-lg">
                      <span className="text-sm font-medium">Wi-Fi & Parking</span>
                      <span className="text-primary text-sm">✓ Free</span>
                    </div>
                  </div>

                  <Button asChild className="w-full bg-primary hover:bg-primary/90 text-lg py-6 mb-4">
                    <Link to="/book">Book Now</Link>
                  </Button>

                  <Button variant="outline" asChild className="w-full">
                    <Link to="/contact">Contact for Special Rates</Link>
                  </Button>

                  <div className="mt-6 pt-4 border-t border-border">
                    <div className="flex flex-col space-y-1 text-sm text-muted-foreground">
                      <div className="flex items-center space-x-2">
                        <Phone className="h-4 w-4" />
                        <a href="tel:+255790222305" className="hover:text-primary transition-colors">
                          +255 790 222 305
                        </a>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox Dialog */}
      <Dialog open={lightboxOpen} onOpenChange={setLightboxOpen}>
        <DialogContent className="max-w-7xl w-full p-0 bg-black/95 border-none">
          <button onClick={() => setLightboxOpen(false)} className="absolute top-4 right-4 z-50 p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors">
            <X className="h-6 w-6 text-white" />
          </button>
          
          {/* Previous Button */}
          <button onClick={prevImage} className="absolute left-4 top-1/2 -translate-y-1/2 z-50 p-3 rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="Previous image">
            <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          {/* Next Button */}
          <button onClick={nextImage} className="absolute right-4 top-1/2 -translate-y-1/2 z-50 p-3 rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="Next image">
            <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>

          <div className="relative w-full h-[90vh] flex items-center justify-center p-4">
            <img src={room.images[lightboxImageIndex]} alt={`${room.name} - View ${lightboxImageIndex + 1}`} className="max-w-full max-h-full object-contain" />
          </div>
          
          {/* Image Counter */}
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-50 px-4 py-2 rounded-full bg-white/10 text-white text-sm">
            {lightboxImageIndex + 1} / {room.images.length}
          </div>
        </DialogContent>
      </Dialog>
    </div>;
};
export default RoomDetail;